var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM16 8.33333C15.4477 8.33333 15 8.78105 15 9.33333C15 9.88562 15.4477 10.3333 16 10.3333H16.012C16.5643 10.3333 17.012 9.88562 17.012 9.33333C17.012 8.78105 16.5643 8.33333 16.012 8.33333H16ZM14.6667 13.6667C14.1144 13.6667 13.6667 14.1144 13.6667 14.6667C13.6667 15.219 14.1144 15.6667 14.6667 15.6667H15V22.6667C15 23.219 15.4477 23.6667 16 23.6667C16.5523 23.6667 17 23.219 17 22.6667V14.6667C17 14.1144 16.5523 13.6667 16 13.6667H14.6667Z",
    fill: "url(#paint0_linear_2013_20203)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2013_20203",
    x1: 3.01868,
    y1: 16,
    x2: 29.0187,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.5c2aee08bfb106a8285258da10c8fda2.svg";
export { ForwardRef as ReactComponent };